import { Injectable } from "@angular/core";
import { SMALL_DEVICES_WIDTH_THRESHOLD } from "@helpers/constants";

@Injectable({
	providedIn: "root"
})
export class WindowResizeService {
	private mobileWindowWidth: number = 0;

	public constructor() {
		window.addEventListener("resize", this.onResize.bind(this));
		this.onResize();
	}

	public isMobile(threshhold: number = SMALL_DEVICES_WIDTH_THRESHOLD): boolean {
		return this.mobileWindowWidth <= threshhold;
	}

	private onResize(): void {
		this.mobileWindowWidth = window.innerWidth;
	}
}
